<template>
  <div class="collection-item-box" @click="$modal.open('recurrence', recurrence)">
    <h2 class="truncate" v-text="recurrence.customer.name"></h2>
    <p class="text-sm" v-text="generationEnd"></p>
    <hr>
    <div class="flex">
      <div class="mr-1 h-6 w-6 flex items-center justify-center border rounded"
           :class="dayClass(day)"
           v-for="day in 7"
           :key="day">{{ dayName(day) }}</div>
    </div>
    <hr>
    <div class="flex justify-between">
      <div>
        <vue-tag icon="cupcake-solid">{{ recurrence.products.length }}</vue-tag>
        <vue-tag icon="hide-password-solid" v-if="!recurrence.active" class="bg-red-lightest text-red"></vue-tag>
      </div>
      <vue-tag icon="note-list-solid">{{ recurrence.orders_count }}</vue-tag>
    </div>
  </div>
</template>

<script>
/* globals moment */

import { ucfirst, formatWeekday } from '../../core/helpers';

export default {
  props: {
    recurrence: {
      type: Object,
      required: true,
    },
  },

  computed: {
    generationEnd() {
      if (
        this.recurrence.periods.filter(period => period.end === null).length
      ) {
        return 'Indéfiniment';
      }

      const end = this.recurrence.periods
        .map(period => period.end)
        .sort((current, next) => moment(current) - moment(next))
        .pop();

      return ucfirst(moment(end).format('ddd DD MMMM YYYY'));
    },
  },

  methods: {
    dayName(day) {
      return formatWeekday(day)[0];
    },

    dayClass(day) {
      const days = this.recurrence.pickups.map(pickup => pickup.day);
      return days.includes(day)
        ? 'bg-green-lightest border-green-light text-green-light'
        : '';
    },
  },
};
</script>